import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import DocLink from 'ui-forms-components/links/DocLink';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { getDeleteLangKey } from 'asset-actions-lib-forms/utils/getLangKey';
import RemoveSimpleWorkflowsModalSection from 'asset-actions-lib-forms/delete/AsyncRemoveSimpleWorkflowsModalSection';
import { WHAT_HAPPENS_DELETE_FORM } from 'FormsCommonComponents/constants/KCSArticlePaths';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function FormDeletePromptModal({
  handleClose,
  handleDelete,
  formType,
  formName,
  hasHubSpotPagesAccess,
  isDeleteLoading,
  guid
}) {
  const shouldRenderHelpLink = useMemo(() => formType !== 'CAPTURED', [formType]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleClose
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getDeleteLangKey(formType, 'deletionPrompt.confirmationHeading'),
          options: {
            formName
          }
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsxs(Text, {
        as: "p",
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: getDeleteLangKey(formType, 'deletionPrompt.confirmationDescription'),
          options: {
            formName
          }
        }), ' ', hasHubSpotPagesAccess && formType !== 'CAPTURED' ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: getDeleteLangKey(formType, 'deletionPrompt.confirmationDescriptionLandingPage')
        }) : null]
      }), (formType === 'HUBSPOT' || formType === 'FLOW') && /*#__PURE__*/_jsx(Text, {
        "data-test-id": "workflows-section",
        children: /*#__PURE__*/_jsx(RemoveSimpleWorkflowsModalSection, {
          guid: guid,
          formType: formType
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: shouldRenderHelpLink && /*#__PURE__*/_jsx(DocLink, {
          path: WHAT_HAPPENS_DELETE_FORM,
          useZorse: false,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getDeleteLangKey(formType, 'deletionPrompt.helpLink')
          })
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "danger",
        onClick: handleDelete,
        disabled: isDeleteLoading,
        "data-test-id": "final-confirmation-delete",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getDeleteLangKey(formType, 'deletionPrompt.finalConfirmation')
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        onClick: handleClose,
        disabled: isDeleteLoading,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLib.modals.shared.cancelButton"
        })
      })]
    })]
  });
}